interface ProjectMeta {
  customTitle?: string;
  keyTerms?: string;
  titleEditedByUser?: boolean;
}

const KEY_PREFIX = "eduarta_project_meta_";

export function getProjectMeta(jobId: number): ProjectMeta | null {
  try {
    const raw = localStorage.getItem(`${KEY_PREFIX}${jobId}`);
    if (!raw) return null;
    return JSON.parse(raw) as ProjectMeta;
  } catch {
    return null;
  }
}

export function setProjectMeta(jobId: number, meta: Partial<ProjectMeta>): void {
  const existing = getProjectMeta(jobId) ?? {};
  const merged = { ...existing, ...meta };
  localStorage.setItem(`${KEY_PREFIX}${jobId}`, JSON.stringify(merged));
}
